import { arrDec, arrInc } from '../../../fun-js-lib/arr'
import { canvasCanTextFit, canvasFillStyled, canvasFonted, canvasLine, canvasText, canvasTextBounded, canvasTextWidthFonted } from '../../../fun-js-lib/canvas'
import Arrow from '../../../fun-js-lib/geometry/Arrow'
import Dot from '../../../fun-js-lib/geometry/Dot'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { spaces } from '../../../fun-js-lib/str'
import { upperLeftRect } from './upperLeft'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
export function drawUpperMiddleLines (context, linesColor) {
  let arrow = Arrow.horizontal({
    xStart: upperMiddleRect().x + horizontalMargin,
    xEnd: upperMiddleRect().x + upperMiddleRect().w - horizontalMargin,
    y: upperMiddleRect().y + lineInterval
  })
  const labelWidth = canvasTextWidthFonted(context, label, labelFont)
  canvasFillStyled(context, linesColor, () => {
    canvasLine({
      context,
      arrow: arrow.movedStart({ x: labelWidth + textPadding }),
      style: linesColor
    })
    canvasLine({
      context,
      arrow: arrow.moved({ y: lineInterval }),
      style: linesColor
    })
    canvasLine({
      context,
      arrow: arrow.moved({ y: lineInterval * 2 }),
      style: linesColor
    })
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function textUpperMiddle (context, linesColor, page) {
  textContent(context, page)
  textLabel(context, linesColor)
}

export function upperMiddleRect () {
  let upperLeft = upperLeftRect()
  return Rect.plain({
    x: upperLeft.x + 1000,
    y: upperLeft.y,
    w: 790,
    h: upperLeft.h
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
function textContent (context, page) {
  const text = getContent(page)
  const rect = Rect.plain({
    x: upperMiddleRect().x + horizontalMargin,
    y: upperMiddleRect().y,
    w: contentWidth,
    h: upperMiddleRect().h
  })
  // Adding spaces to skip investor label text
  const { font, nSpaces } = contentFontAndSpaces(context, text)
  canvasFonted(context, font, () => {
    canvasTextBounded(context, spaces(nSpaces) + text, rect, lineInterval)
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../../constructionLog').LogPage} page 
 */
const getContent = page =>
  page.investor_legal_entity_name +
  (page.investor_legal_entity_address === '' ?
    '' :
    ', ' + page.investor_legal_entity_address)

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 */
function contentFontAndSpaces (context, text) {
  const maxSize = 42
  const fontSize = arrDec(maxSize + 1)
    .find(fontSize => {
      const font = fontSize + 'px Arial'
      return canvasCanTextFit({
        context,
        text: spaces(nSpacesToSkipInvestorLabel(context, font)) + text,
        font,
        maxNLines: 3,
        maxWidth: contentWidth
      })
    })
  const font = fontSize + 'px Arial'
  return {
    font,
    nSpaces: nSpacesToSkipInvestorLabel(context, font)
  }
}

/**
 * @param {string} font 
 */
function nSpacesToSkipInvestorLabel (context, font) {
  const nSpacesThatIsCertainlyEnough = 100
  return arrInc(nSpacesThatIsCertainlyEnough)
    .find(n => {
      const spacesWidth = canvasTextWidthFonted(context, spaces(n), font)
      return spacesWidth >= labelWidth(context) + textPadding
    })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 */
function textLabel (context, linesColor) {
  const rect = upperMiddleRect()
  canvasFillStyled(context, linesColor, () => {
    let position = new Dot({
      x: rect.x + horizontalMargin,
      y: rect.y + lineInterval
    })
    canvasText(context, label, position)
  })
}

const horizontalMargin = 20

const lineInterval = 70

const textPadding = 8

const label = 'ИНВЕСТИТОР'

const labelFont = '30px Arial'

/**
 * @param {CanvasRenderingContext2D} context 
 */
const labelWidth = context =>
  canvasTextWidthFonted(context, label, labelFont)

const contentWidth =
  upperMiddleRect().w - horizontalMargin * 2